module.exports = __webpack_public_path__ + "img/136-Achatgrau SFTN.jpg";